<template>
    <span :class="['font-weight-bold', labelClass]">
        <slot></slot>
    </span>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                validator: v => ['default', 'success', 'error', 'info', 'warning'].includes(v),
            },
        },
        computed: {
            labelClass() {
                switch (this.type) {
                    case 'success':
                        return 'text-success';
                    case 'error':
                        return 'text-danger';
                    case 'info':
                        return 'text-info';
                    case 'warning':
                        return 'text-warning';
                    default:
                        return 'text-muted';
                }
            },
        },
    };
</script>
